import React, { useContext, useState } from 'react';
import './PrivacyTermsAndConditions.css';
import {Footer} from '@nxtvid/component-library';

const PrivacyTermsAndConditions = () => {
    
    const [currentTab, setCurrentTab] = useState('PrivacyPolicy');


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
    
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            const offset = 115; // Adjust this value to set your desired offset
    
            if (targetElement) {
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    return(
        <div>
            <div className="App-body-PrivacyTermsAndConditions" >
            <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
            <div className="tab-container">
                    <div className={`tab ${currentTab === 'PrivacyPolicy' ? 'active' : ''}`} onClick={() => setCurrentTab('PrivacyPolicy')}>
                        Privacy Policy
                    </div>
                    <div className={`tab ${currentTab === 'TermsAndConditions' ? 'active' : ''}`} onClick={() => setCurrentTab('TermsAndConditions')}>
                        Terms and Conditions
                    </div>
                </div>
                <div className="tab-content">
                    {currentTab === 'PrivacyPolicy' ? (
                        <div className='PrivacyPolicyInformation'>
                            <h1>Privacy Policy</h1>
                            <p>Last Update: February 2025</p>
                            <hr/>
                            <p>
                            PLEASE READ THE FOLLOWING CAREFULLY
                            </p>
                            <p>
                            THIS STATEMENT PROVIDES GENERAL INFORMATION ABOUT THE PRIVACY POLICY OF THIS WEBSITE. OUR SERVICES ARE INTENDED FOR USERS 18 YEARS AND OLDER. IF YOU ARE UNDER 18, WE ASK THAT YOU DO NOT PROVIDE ANY PERSONAL INFORMATION OR USE OUR SERVICES WITHOUT PARENTAL CONSENT.
                            </p>
                            <p>
                            YOUR USE OF THIS SERVICE CONSTITUTES ACCEPTANCE BY YOU OF THIS PRIVACY POLICY. 
                            </p>
                            <hr/>

<h2>TL;DR (Summary)</h2>
<ul>
    <li>We respect your privacy. Your data is <strong>never sold</strong> to third parties.</li>
    <li>Videos you upload may be analyzed, tagged, and sliced into clips for the Explore page.</li>
    <li>We collect interaction data and input data to improve our Services.</li>
    <li>We share your data only when necessary to deliver services (e.g., Stripe for payments or OpenAI for personalized results).</li>
    <li>You control your data. You can access, modify, or delete it at any time.</li>
    <li>Your data is protected with <strong>industry-standard security measures</strong>, including encrypted storage and signed URLs for access control.</li>
</ul>
<hr/>
<h2>Table of Contents</h2>
<div className="toc">
    <ul>
        <li><a href="#introduction">Introduction</a></li>
        <li><a href="#information-collect">Information We Collect</a></li>
        <li><a href="#how-we-use">How We Use Your Information</a></li>
        <li><a href="#data-sharing">Data Sharing and Third Parties</a></li>
        <li><a href="#data-retention">Data Retention</a></li>
        <li><a href="#data-security">Data Security</a></li>
        <li><a href="#your-rights">Your Rights</a></li>
        <li><a href="#cookies">Cookies and Tracking Technologies</a></li>
        <li><a href="#data-transfers">Data Transfers</a></li>
        <li><a href="#minors">Minors</a></li>
        <li><a href="#changes">Changes to This Policy</a></li>
        <li><a href="#contact">Contact Us</a></li>
    </ul>
</div>

<hr/>

<h2 id="introduction">1. Introduction</h2>
<p>NXTVid Inc. ("NXTVid," "we," "our," or "us") respects your privacy. This Privacy Policy explains how we collect, use, share, and protect the personal information you provide when using our website and services.</p>
<p>We comply with applicable privacy laws, including but not limited to:</p>
<ul>
    <li><strong>Florida Information Protection Act (FIPA)</strong></li>
    <li><strong>California Consumer Privacy Act (CCPA)</strong></li>
    <li><strong>California Online Privacy Protection Act (CALOPPA)</strong></li>
    <li><strong>General Data Protection Regulation (GDPR)</strong> (for applicable EU users)</li>
</ul>
<hr/>
<h2 id="information-collect">2. Information We Collect</h2>
<p>We collect the following types of information:</p>
<ul>
    <li><strong>Information You Provide Directly:</strong> Contact details, payment details (via Stripe), and uploaded content (e.g., videos).</li>
    <li><strong>Data Collected Through Use:</strong> Interaction data, input data, and video metadata analyzed by AI.</li>
    <li><strong>Automated Data Collection:</strong> IP addresses, device information, cookies, and location data.</li>
</ul>
<hr/>
<h2 id="how-we-use">3. How We Use Your Information</h2>
<p>Your data is used to:</p>
<ul>
    <li>Deliver and improve our services.</li>
    <li>Process payments securely.</li>
    <li>Analyze videos using AI for tagging and slicing functionality.</li>
    <li>Enhance your user experience.</li>
    <li>Respond to inquiries and comply with legal obligations.</li>
</ul>
<hr/>
<h2 id="data-sharing">4. Data Sharing and Third Parties</h2>
    <p>We do not sell your data. We share it only when necessary, such as with:</p>
    <ul>
        <li><strong>Google Analytics (GA):</strong> Tracks user behavior for marketing and site performance optimization. <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">Google’s Privacy Policy</a></li>
        <li><strong>Mixpanel:</strong> Collects event-based usage data to analyze how users engage with our platform. <a href="https://mixpanel.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">Mixpanel’s Privacy Policy</a></li>
        <li><strong>Sentry:</strong> Logs application errors and performance data to help us diagnose and fix technical issues. <a href="https://sentry.io/privacy/" target="_blank" rel="noopener noreferrer">Sentry’s Privacy Policy</a></li>
        <li><strong>Stripe:</strong> Processes payments securely. <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">Stripe’s Privacy Policy</a></li>
        <li><strong>OpenAI:</strong> Provides personalized results. <a href="https://openai.com/policies/row-privacy-policy/" target="_blank" rel="noopener noreferrer">OpenAI’s Privacy Policy</a></li>
        <li>Legal authorities when required by law.</li>
    </ul>
<hr/>
<h2 id="data-retention">5. Data Retention</h2>
<p>We retain your data as long as needed to provide our services or comply with legal obligations. When deleted, data (including video metadata) is fully scrubbed from our servers.</p>
<hr/>
<h2 id="data-security">6. Data Security</h2>
<p>We use industry-standard security measures, including:</p>
<ul>
    <li>Encrypted data transfer using SSL.</li>
    <li>Secure storage with firewalls.</li>
    <li>Signed URLs for secure access to content.</li>
</ul>
<hr/>
<h2 id="your-rights">7. Your Rights</h2>
<p>You have the right to access, modify, delete, or restrict how your data is processed. Contact us at <a href="mailto:support@nxtvid.io">support@nxtvid.io</a> to exercise these rights.</p>
<hr/>
<h2 id="cookies">8. Cookies and Tracking Technologies</h2>
    <p>We use <strong>Google Analytics (GA), Mixpanel, and Sentry</strong>, which may collect data through <strong>cookies, mobile identifiers, and event tracking scripts</strong> to provide insights on user behavior and system performance.</p>
    <ul>
        <li><strong>GA and Mixpanel</strong> use cookies to track site interactions, engagement metrics, and feature usage.</li>
        <li><strong>Sentry</strong> may collect real-time error reports, including device and session information, to monitor system stability.</li>
    </ul>
    <p>Users can opt-out of tracking through:</p>
    <ul>
        <li><a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-Out</a></li>
    </ul>
    <p>Where required, we provide a cookie consent tool that allows users to accept or decline analytics tracking.</p>
<hr/>
<h2 id="data-transfers">9. Data Transfers</h2>
<p>Your data may be transferred outside your jurisdiction, including to the United States. We ensure appropriate safeguards are in place.</p>
<hr/>
<h2 id="minors">10. Minors</h2>
<p>Our services are not intended for individuals under 18. If you believe we have collected such data, contact us to delete it.</p>
<hr/>
<h2 id="changes">11. Changes to This Policy</h2>
<p>We may update this Privacy Policy. Changes will be communicated, and continued use of the Services constitutes acceptance.</p>
<hr/>
<h2 id="contact">12. Contact Us</h2>
<p>If you have any questions or concerns, please contact us at <a href="mailto:support@nxtvid.io">support@nxtvid.io</a></p>
                        </div>
                    ) : (
                        <div className='TermsAndConditionsInformation'>
                            <h1>Terms and Conditions</h1>
                            <p>Last Update: February 2025</p>
                            <hr/>
                            <p>
                            PLEASE READ THE FOLLOWING CAREFULLY
                            </p>
                            <p>
                            THIS STATEMENT PROVIDES GENERAL INFORMATION ABOUT THE TERMS AND CONDITIONS OF THIS WEBSITE. OUR SERVICES ARE INTENDED FOR USERS 18 YEARS AND OLDER. IF YOU ARE UNDER 18, WE ASK THAT YOU DO NOT PROVIDE ANY PERSONAL INFORMATION OR USE OUR SERVICES WITHOUT PARENTAL CONSENT.
                            </p>
                            <p>
                            YOUR USE OF THIS SERVICE CONSTITUTES ACCEPTANCE BY YOU OF THESE TERMS AND CONDITIONS. 
                            </p>
                            <hr/>
                            <h2>TL;DR (Summary)</h2>
  <ul>
    <li><strong>Content Use</strong>: Videos you upload are processed by AI for tagging, slicing into clips, and display on our Explore page.</li>
    <li><strong>Data Usage</strong>: We collect interaction data and user-input data to improve services. We do NOT sell your data. We only share it with third parties when required to deliver services (e.g., OpenAI for personalized results, Stripe for payments).</li>
    <li><strong>Transaction Fees</strong>: Videographers pay a 13% facilitation fee for any deals made on the platform.
      <ul>
        <li>Businesses pay a 50% deposit upfront: 26% of the total goes to us, and 24% to the videographer.</li>
        <li>At project completion, the remaining 50% is sent to the videographer.</li>
      </ul>
    </li>
  </ul>
  <hr />

  <h2>Table of Contents</h2>
  <div className='toc'>
  <ul>
    <li><a href="#agreement-to-terms">Agreement to Terms</a></li>
    <li><a href="#service-overview">Service Overview</a></li>
    <li><a href="#intellectual-property">Intellectual Property Rights</a></li>
    <li><a href="#user-responsibilities">User Responsibilities</a></li>
    <li><a href="#content-and-data">Content and Data Usage</a></li>
    <li><a href="#transaction-fees">Transaction and Service Fees</a></li>
    <li><a href="#booking-process">Booking Process and Payments</a></li>
    <li><a href="#cancellations">Cancellations and Refunds</a></li>
    <li><a href="#liability">Limitations of Liability</a></li>
    <li><a href="#contact">Contact Us</a></li>
  </ul>
    </div>
  <hr />

  <h2 id="agreement-to-terms">1. Agreement to Terms</h2>
  <p>By using NxtVid ("we," "our," or "us"), you agree to these Terms of Service. If you don’t agree, you may not use our services. We may update these terms from time to time, and continued use of the platform indicates acceptance of any changes.</p>
  <hr />

  <h2 id="service-overview">2. Service Overview</h2>
  <p>NxtVid connects businesses with videographers and production studios. Videographers upload their portfolios, and businesses can compare and hire based on their needs. By uploading content, users agree that NxtVid will:</p>
  <ul>
    <li>Process videos using AI to tag, slice, and display clips on our Explore page.</li>
    <li>Use uploaded content to improve searchability and platform performance.</li>
  </ul>
  <p>We do not claim ownership of uploaded content but require rights to process and display it for platform functionality.</p>
  <hr />

  <h2 id="intellectual-property">3. Intellectual Property Rights</h2>
  <p>All content, trademarks, logos, and platform designs are the property of NxtVid or its licensors. Users may not copy, reproduce, or exploit any part of the platform without our written consent.</p>
  <p>Users retain ownership of their uploaded content but grant NxtVid the right to process, display, and use it for delivering services.</p>
  <hr />

  <h2 id="user-responsibilities">4. User Responsibilities</h2>
  <p>By using NxtVid, you agree to:</p>
  <ul>
    <li>Provide accurate and up-to-date information.</li>
    <li>Ensure all uploaded content complies with applicable laws and does not infringe on third-party rights.</li>
    <li>Avoid unauthorized, illegal, or harmful activities on the platform.</li>
    <li>Users must not upload NSFW (Not Safe for Work) content, including but not limited to sexually explicit material. Any content deemed NSFW will be removed immediately, and the uploader will receive a formal warning.</li>
    <li>If a user uploads NSFW content a second time, their listing will be permanently removed, and they will be banned from our videographer network.</li>
  </ul>
  <p>We reserve the right to suspend or terminate accounts that violate these responsibilities.</p>
  <hr />

  <h2 id="content-and-data">5. Content and Data Usage</h2>
  <ul>
    <li><strong>Uploaded Content</strong>: Videos, images, and other media you upload will be processed by AI for tagging, slicing, and organization.</li>
    <li><strong>Data Collection</strong>: We collect application interaction data (e.g., clicks, searches) and user-input data (e.g., preferences, proposals).</li>
    <li><strong>Third-Party Sharing</strong>: Data is shared only with third parties essential to service delivery, such as:
      <ul>
        <li>OpenAI for personalized tagging.</li>
        <li>Stripe for secure payment processing.</li>
      </ul>
    </li>
    <li><strong>No Data Selling</strong>: We do not sell user data to third parties.</li>
  </ul>
  <hr />

  <h2 id="transaction-fees">6. Transaction and Service Fees</h2>
  <p>To keep the platform running, we charge fees for successful transactions:</p>
  <ul>
    <li><strong>13% Facilitation Fee</strong>: Paid by the videographer.</li>
    <li><strong>Payment Process</strong>:
      <ul>
        <li><strong>50% Deposit</strong>: Businesses pay 50% upfront when a proposal is accepted.
          <ul>
            <li>26% of the total goes to NxtVid.</li>
            <li>24% of the total goes to the videographer.</li>
          </ul>
        </li>
        <li><strong>Completion Payment</strong>: The remaining 50% is sent to the videographer upon project completion.</li>
      </ul>
    </li>
  </ul>
  <hr />

  <h2 id="booking-process">7. Booking Process and Payments</h2>
  <ol>
    <li><strong>Proposal Submission</strong>: Videographers submit proposals for businesses to review.</li>
    <li><strong>Payment Schedule</strong>: Businesses pay a 50% deposit upfront, and the remaining 50% upon completion.</li>
    <li><strong>Disputes</strong>: NxtVid facilitates connections but is not responsible for disputes regarding deliverables or quality.</li>
  </ol>
  <hr />

  <h2 id="cancellations">8. Cancellations and Refunds</h2>
  <ol>
    <li><strong>Deposits</strong>: Deposits are non-refundable unless agreed otherwise.</li>
    <li><strong>Cancellations</strong>: Businesses and videographers must resolve cancellations independently.</li>
  </ol>
  <hr />

  <h2 id="liability">9. Limitations of Liability</h2>
  <p>NxtVid facilitates connections but is not responsible for:</p>
  <ul>
    <li>The quality, delivery, or outcomes of projects.</li>
    <li>Content uploaded by users.</li>
    <li>Indirect, incidental, or consequential damages from platform use.</li>
  </ul>
  <p>Our total liability is limited to the fees paid to us.</p>
  <hr />

  <h2 id="contact">10. Contact Us</h2>
  <p>If you have any questions or concerns, please contact us at <a href="mailto:support@nxtvid.io">support@nxtvid.io</a></p>

                        </div>
                    )}
                </div>
            </div>
            <footer>
                <Footer/>
            </footer> 
        </div>
    )
}
export default PrivacyTermsAndConditions;